import type { Artist } from '~/types';
import React from 'react';
import DesktopCard from './DesktopArtistCard';

interface StageSectionProps {
  stage: string;
  performances: Artist[];
  onArtistClick?: (artist: string) => void;
}
const cdnBasePath = 'http://assets.malomfesztival.org';

const StageSection: React.FC<StageSectionProps> = ({ performances, stage, onArtistClick }) => {
  return (
    <div className="mb-10 md:mb-12">
      <div className="flex">
        <div className="bg-orange flex items-center justify-center p-2 text-white md:p-3 lg:p-4">
          <h2
            className="origin-center rotate-180 transform text-xl font-bold tracking-wider whitespace-nowrap [writing-mode:vertical-rl] md:text-2xl"
          >
            {stage.toUpperCase()}
          </h2>
        </div>
        <div className="grid flex-grow grid-cols-1 gap-4 bg-[#3A3A3A]/50 p-4 sm:grid-cols-2 md:grid-cols-4 md:gap-6 md:p-6 lg:grid-cols-5">
          {performances.map(perf => (
            <div key={perf.Slug} onClick={() => onArtistClick?.(perf.Name)}>
              <DesktopCard day={perf.Day} bandName={perf.Name} slug={perf.Slug} image={`${cdnBasePath}${perf.Image}`} />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default StageSection;
